import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuthContext } from "@/contexts/AuthContext";

export const POST_AUTH_REDIRECT_KEY = "wpm_post_auth_redirect";

// Catches users who land on the wrong page after Google OAuth or an
// email-confirmation link — both round-trip through external services
// that may not preserve the `redirect` query param. Auth.tsx writes the
// intended target to sessionStorage before initiating those flows;
// this component consumes it once the session materializes.
export function PostAuthRedirect() {
  const { user, loading } = useAuthContext();
  const navigate = useNavigate();
  const location = useLocation();
  const consumed = useRef(false);

  useEffect(() => {
    if (loading || !user || consumed.current) return;
    const target = sessionStorage.getItem(POST_AUTH_REDIRECT_KEY);
    if (!target) return;
    sessionStorage.removeItem(POST_AUTH_REDIRECT_KEY);
    consumed.current = true;

    const targetPath = target.split(/[?#]/)[0];
    if (location.pathname === targetPath) return;

    navigate(target, { replace: true });
  }, [user, loading, location.pathname, navigate]);

  return null;
}
